import warningIcon from "$assets/icons/warning-icon.svg?url";
import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import { linkToCreateCustomItems } from "$routes/price-list/links";
import { gql } from "@apollo/client";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";

gql`
  mutation createCustomItems($input: createCustomItemsInput!) {
    priceListV2 {
      createCustomItems(input: $input) {
        items {
          id
          name
        }
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  warningIcon: {
    marginRight: theme.spacing(2),
  },
}));

export interface CreateCustomItemsModalProps {
  open: boolean;
  onClose: () => void;
  priceListId: string;
}

export const CreateCustomItemsModal = ({
  open,
  onClose,
  priceListId,
}: CreateCustomItemsModalProps) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const confirm = () => {
    navigate(linkToCreateCustomItems(priceListId), {
      state: { from: location.pathname + location.search },
    });
    onClose();
  };

  return (
    <DialogContainer open={open}>
      <DialogHeader title="">
        <Box display="flex" alignItems="center">
          <img
            src={warningIcon}
            alt="warning"
            className={classes.warningIcon}
          />
          <Typography variant="h5">
            <FormattedMessage
              id="pricelist.modal.createCustomItems.modal.title"
              defaultMessage="Create Custom Item"
            />
          </Typography>
        </Box>
      </DialogHeader>
      <DialogBody>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body1">
              <FormattedMessage
                id="pricelist.modal.createCustomItems.description"
                defaultMessage="Custom Items will not automatically appear when creating the invoices since they will not be connected to clinical items.  If you want this item to automatically appear on your invoice please contact Elephant Helpdesk to add it."
              />
            </Typography>
          </Grid>
        </Grid>
      </DialogBody>
      <DialogFooter>
        <Button color="secondary" onClick={() => onClose()}>
          <FormattedMessage
            id="pricelist.modal.createCustomItems.cancel"
            defaultMessage="Cancel"
          />
        </Button>
        <Button
          onClick={confirm}
          data-testid="pricelist.modal.createCustomItems.accept"
        >
          <FormattedMessage
            id="pricelist.modal.createCustomItems.confirm"
            defaultMessage="Create Custom Item"
          />
        </Button>
      </DialogFooter>
    </DialogContainer>
  );
};

export default CreateCustomItemsModal;
